(function () {

  function sendEvent(eventName, props) {
    if (
      !window.Shopify ||
      !Shopify.analytics ||
      typeof Shopify.analytics.publish !== 'function'
    ) {
      console.warn('[SizeGuide] Shopify.analytics.publish not available, event skipped →', eventName, props);
      return;
    }

    const baseProps = Object.assign(
      {},
      props || {},
      {
        product_id:     window.__PRODUCT_ID__    || null,
        product_title:  window.__PRODUCT_TITLE__ || null,
        product_type:   window.__PRODUCT_TYPE__  || null
      }
    );

    if (window.__SHOPIFY_CUSTOMER_ID__) {
      baseProps['$user_id'] = String(window.__SHOPIFY_CUSTOMER_ID__);
    }

    Shopify.analytics.publish(eventName, baseProps);
    // console.log('[SizeGuide] Sent event →', eventName, baseProps);
  }

  const seenRecs = new Set();
  const seenLogs = new Set();

  function logOnce(key, msg, ...rest) {
    if (seenLogs.has(key)) return;
    seenLogs.add(key);
    console.log(msg, ...rest);
  }

  function logRec(size) {
    if (!size) return;
    const clean = size.replace(/\s+/g, ' ').trim();
    if (seenRecs.has(clean)) return;
    seenRecs.add(clean);
  }

  function throttle(fn, ms) {
    let last = 0;
    return (...args) => {
      const now = Date.now();
      if (now - last < ms) return;
      last = now;
      fn(...args);
    };
  }

  function isGuideMode() {
    const root = document.querySelector('#measmerize-button');
    if (!root) return false;
    const txt = (root.textContent || '').toLowerCase();
    return /find your size|size guide/.test(txt) && !/recommended:/.test(txt);
  }

  // --- 1) Size Guide Opened ---
  const onSizeGuideClick = throttle(() => {
    if (!isGuideMode()) return;

    sendEvent('Size Guide Opened', {
      used_size_guide: true,
      origin: 'PDP button'
    });

    logOnce('opened', '[SizeGuide] Size Guide Opened event sent');
  }, 400);

  document.addEventListener('click', (e) => {
    if (e.target.closest('#measmerize-button')) {
      onSizeGuideClick();
    }
  });

  const REC_SELECTOR   = '._slideItem_afjs2_17 > span._active_afjs2_32._recommended_afjs2_40';
  const ACTIVE_SELECTOR = '._slideItem_afjs2_17 > span._active_afjs2_32';

  const mo = new MutationObserver(() => {
    // Recommended size shown
    const recEl = document.querySelector(REC_SELECTOR);
    if (recEl) {
      const recommendedSize = (recEl.textContent || '').trim();
      if (recommendedSize) {
        logRec(recommendedSize);

        sendEvent('Size Recommendation Shown', {
          recommended_size: recommendedSize,
          used_size_guide: true,
          origin: 'Size guide modal'
        });

        logOnce(
          'rec:' + recommendedSize,
          '[SizeGuide] Recommendation shown →',
          recommendedSize
        );
      }
      return;
    }

    // User browses sizes in modal (non-recommended)
    const active = document.querySelector(ACTIVE_SELECTOR);
    if (active && !active.matches('._recommended_afjs2_40')) {
      const sizeViewed = (active.textContent || '').trim();
      if (!sizeViewed) return;

      sendEvent('Size Option Viewed (Modal)', {
        size_viewed: sizeViewed,
        used_size_guide: true
      });

      logOnce('browsed:' + sizeViewed, '[SizeGuide] Modal size browsed →', sizeViewed);
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // 3) Custom Add To Cart, tied to Size Guide ---
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#AddToCart, .single-add-cart-button, .single-add-to-cart-button');
    if (!btn) return;

    // Get selected size from your PDP (adapt selector if needed)
    const sizeInput = document.querySelector('input[name="Size"]:checked');
    const selectedSize = sizeInput ? sizeInput.value : null;

    // Recommendation visible in the button
    const recEl = document.querySelector('#measmerize-button ._recommendation_1wwlt_23');
    const recommendedSize = recEl ? recEl.textContent.trim() : null;

    const matchedRecommendation = recommendedSize ? (selectedSize === recommendedSize) : null;
    const usedSizeGuide        = !!recommendedSize;

    sendEvent('SizeGuide_AddToCart', {
      size_selected: selectedSize,
      recommended_size: recommendedSize,
      matched_recommendation: matchedRecommendation,
      used_size_guide: usedSizeGuide
    });

    // console.log('[SizeGuide] Custom AddToCart event sent');
  });


  function trackStep(stepNameOrNumber) {
    sendEvent('Size Guide Proceed', {
      step: stepNameOrNumber,
      used_size_guide: true
    });
  }

  // --- 5) Persistent recommendation directly on PDP (no modal interaction) ---
  function initPersistentRecommendation() {
    const el = document.querySelector('#measmerize-button ._recommendation_1wwlt_23');
    if (!el) return;
    const val = (el.textContent || '').trim();
    if (val) {
      logOnce('persistent:' + val, '[SizeGuide] Persistent recommendation on PDP →', val);
      logRec(val);

      // send "Size Recommendation Shown" here:
      // sendEvent('Size Recommendation Shown', {
      //   recommended_size: val,
      //   used_size_guide: true,
      //   origin: 'PDP persistent'
      // });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersistentRecommendation);
  } else {
    initPersistentRecommendation();
  }
})();
